import { FileModel } from 'api';

export const FIRM_DOCUMENT_PREVIEW_IMAGE_FILE_TYPES = new Set<string>([
  FileModel.file_type.GIF,
  FileModel.file_type.JPEG,
  FileModel.file_type.JPG,
  FileModel.file_type.PNG,
]);

export const FIRM_DOCUMENT_PREVIEW_TEXT_FILE_TYPES = new Set<string>([
  FileModel.file_type.MD,
  FileModel.file_type.RTF,
  FileModel.file_type.TXT,
]);

export const FIRM_DOCUMENT_PREVIEW_SPREADSHEET_FILE_TYPES = new Set<string>([
  FileModel.file_type.CSV,
  FileModel.file_type.XLS,
  FileModel.file_type.XLSX,
  FileModel.file_type.XLSM,
  FileModel.file_type.XLSB,
]);

export const FIRM_DOCUMENT_PREVIEWABLE_FILE_TYPES = new Set<string>([
  ...FIRM_DOCUMENT_PREVIEW_IMAGE_FILE_TYPES,
  ...FIRM_DOCUMENT_PREVIEW_SPREADSHEET_FILE_TYPES,
  ...FIRM_DOCUMENT_PREVIEW_TEXT_FILE_TYPES,
  FileModel.file_type.PDF,
]);
